




























import Vue from 'vue';
import MainStore from '../stores/MainStore';

export default Vue.extend({
  data() {
    return {
      darkMode: MainStore.data.darkMode as string,
      langs: MainStore.data.langs,
    };
  },
  watch: {
    darkMode(val: string): void {
      this.toggleDarkMode(val as string);
    },
  },
  mounted() {
    if (localStorage.getItem('darkMode')) {
      this.toggleDarkMode(localStorage.getItem('darkMode') as string);
    }
  },
  methods: {
    toggleDarkMode(val: string): void {
      if (val === 'true') {
        document.body.classList.add('dark');
        this.darkMode = 'true';
      } else {
        document.body.classList.remove('dark');
        this.darkMode = 'false';
      }
      localStorage.setItem('darkMode', val);
    },
    changeLang(): void {
      localStorage.setItem('langCode', this.$i18n.locale);
      document.title = this.$t('title') as string;
    },
  },
});
